import * as React from 'react';
import BaseComponent from '@/components/BaseComponent';
import { Router, Route, Switch, withRouter, browserHistory } from 'react-router-dom';
import NoMatch from '@/components/NoMatch';
import PageLoading from '@/components/BaseComponent/PageLoading';
import { getUserAgent } from '@/util/handleUrlParams.ts'


/**
 *
 * 渲染路由
 * @class RouterUI
 * @extends {BaseComponent<IProps>}
 */
class RouterUI extends BaseComponent {
  /**
   * 生成router
   * @param {*} routers
   * @param {*} container
   * @param {*} recur 是否递归
   */
  renderRouter = (routers = []) =>
    routers.map(router => {
      let { path, exact, unAuth} = router;
      if (unAuth) { }
      return (
        <Route
          key={path}
          path={path}
          exact={exact ? true : false}
          render={() => this.renderPage(router)}
        />
      );
    });

  renderPage = (router) => {
    const { component, path, loadingFallback, notNeedInWechat, title, ID } = router;
    let Page = component;
      document.title = title || ""
    return (
      <React.Suspense fallback={loadingFallback || <PageLoading />} key={path}>
        <Page ID={ID} />
      </React.Suspense>
    );
  };

  render() {
    const { routers } = this.props;
    return (
      <Switch>
        {this.renderRouter(routers)}
        <Route component={NoMatch} />
      </Switch>

    );
  }
}

export default withRouter(RouterUI);
